// authConfig.js
export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID,
      authority: process.env.REACT_APP_AUTHORITY,
      redirectUri: process.env.REACT_APP_REDIRECT_URI,
      // redirectUri: "http://localhost:3000",
      responseType: "token"
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to true if you are having issues on IE11 or Edge
    }
  };
  
  export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_SCOPE}/impersonate`] // Define the scopes you need
  };